module.exports = __webpack_public_path__ + "img/num1.77ad861c.png";